import React from "react"
import Columns from '../components/columns/Columns';
import Header from '../components/header/Header';
import Helmet from 'react-helmet';

export default ({ data }) => {
  const columns = data.allMarkdownRemark.edges;
  const title = data.site.siteMetadata.title;
  return (
    <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header title={title}/>
      <Columns columns={columns}/>
    </div>
  )
}

export const pageQuery = graphql`
  query Columns {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: {fields: [frontmatter___column], order: ASC}) {
      edges {
        node {
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js